// 每個模型的背景設定（編輯器「背景」分頁 / 平台 ScanKit 編輯頁設定，發佈後由 viewer API 帶回）
//
// 後端欄位（online_product_model）：
// - bgImageSwitch + bgImage：背景圖（bgImage 為 CDN 網址）
// - colorSwitch + color：背景色 #RRGGBB
// 優先序：背景圖 > 背景色 > 預設漸層。開關沒開、或值不合法時一律回到預設，
// 所以沒設定過的既有物件（colorSwitch = false、bgImage = ""）畫面完全不變。

export const DEFAULT_BACKGROUND = "linear-gradient(180deg, #FBFBFB 0%, #E9E9E9 100%)";

const HEX_COLOR = /^#[0-9A-Fa-f]{6}$/;

export const getModelBackground = (model) => {
  if (model?.bgImageSwitch === true && typeof model.bgImage === "string" && model.bgImage.trim()) {
    return { type: "image", url: model.bgImage.trim() };
  }
  if (model?.colorSwitch === true && typeof model.color === "string" && HEX_COLOR.test(model.color)) {
    return { type: "color", color: model.color.toUpperCase() };
  }
  return { type: "default" };
};

// 要拿哪個模型的背景設定：一般物件是目前這個模型；ScanKit 物件（有 360 照片 scanFileList 的模型）
// 一律用照片那個模型的設定，讓附帶的 3D 版本跟照片同一個背景（ScanKit 編輯頁只設定照片模型）
export const getBackgroundSourceModel = (models, currentModel) => {
  const scanModel = Array.isArray(models)
    ? models.find((model) => Array.isArray(model?.scanFileList) && model.scanFileList.length > 0)
    : undefined;
  return scanModel || currentModel;
};

// CSS background 簡寫。網址放進 url("...") 前先跳脫引號與反斜線，避免打斷 CSS
export const toCssBackground = (background) => {
  if (background?.type === "image") {
    const safeUrl = background.url.replace(/\\/g, "\\\\").replace(/"/g, '\\"');
    return `#E9E9E9 url("${safeUrl}") center / cover no-repeat`;
  }
  if (background?.type === "color") return background.color;
  return DEFAULT_BACKGROUND;
};

// 依 WCAG 相對亮度判斷深色，用來決定背景上文字（載入畫面的 iStaging）要用淺色還是深色
export const isDarkColor = (hex) => {
  if (typeof hex !== "string" || !HEX_COLOR.test(hex)) return false;
  const channel = (offset) => {
    const value = parseInt(hex.slice(offset, offset + 2), 16) / 255;
    return value <= 0.03928 ? value / 12.92 : ((value + 0.055) / 1.055) ** 2.4;
  };
  const luminance = 0.2126 * channel(1) + 0.7152 * channel(3) + 0.0722 * channel(5);
  return luminance < 0.179;
};
